module.exports = __webpack_public_path__ + "img/Documento icon.3688a5ab.svg";